import { isSafari } from "react-device-detect";
import { getReadScope } from "../../utils/readCache";

const streams = new Map();
const previews = new Map();
let scope;
function scopedStreams() {
  const next = getReadScope();
  if (scope !== next) {
    streams.clear();
    previews.clear();
    scope = next;
  }
  return streams;
}
export function registerPreview(url, start, end) {
  scopedStreams();
  previews.set(url, { start, end });
}
export function previewRange(url) {
  scopedStreams();
  return previews.get(url);
}
const decodeBase64 = (value) =>
  Uint8Array.from(window.atob(value.trim()), (c) => c.charCodeAt(0));
function fairPlay(stream, headers) {
  return {
    getContentId: (options, initData) => {
      const value = new TextDecoder("utf-16le").decode(initData);
      return value.replace(/^skd:\/\//, "");
    },
    getCertificate: (options, callback) => {
      fetch(stream.FairPlayCertificateUrl)
        .then(async (response) => {
          if (!response.ok) throw new Error("FairPlay sertifikası alınamadı.");
          const bytes = await response.arrayBuffer();
          if (new Uint8Array(bytes)[0] === 0x30) return new Uint8Array(bytes); // DER
          return decodeBase64(new TextDecoder().decode(bytes));
        })
        .then((cert) => callback(null, cert), callback);
    },
    getLicense: (options, contentId, message, callback) => {
      const spc = window.btoa(
        Array.from(new Uint8Array(message), (b) => String.fromCharCode(b)).join(
          ""
        )
      );
      fetch(stream.FairPlayServerUrl, {
        method: "POST",
        headers: {
          ...headers,
          "Content-Type": "application/x-www-form-urlencoded"
        },
        body: `spc=${encodeURIComponent(spc)}`
      })
        .then(async (response) => {
          if (!response.ok) throw new Error("FairPlay lisansı alınamadı.");
          return decodeBase64((await response.text()).replace(/<\/?ckc>/g, ""))
            .buffer;
        })
        .then((license) => callback(null, license), callback);
    }
  };
}
export function streamUrl(stream, { dvr = false, startTime } = {}) {
  if (!stream) throw new Error("Yayın bilgisi bulunamadı.");
  const url = dvr
    ? (isSafari ? stream.HlsDvrStreamUrl : stream.DashDvrStreamUrl) ||
      stream.DefaultDvrStreamUrl
    : (isSafari ? stream.HlsStreamUrl : stream.DashStreamUrl) ||
      stream.DefaultStreamUrl ||
      stream.HlsStreamUrl;
  if (!url) throw new Error("Yayın adresi bulunamadı.");
  scopedStreams().set(url, { ...stream, requestedStartTime: startTime });
  return url;
}
export function seekDvrStart(player, url, now = Date.now()) {
  const value = scopedStreams().get(url)?.requestedStartTime;
  if (!value) return;
  const requested = Number.isFinite(Number(value))
    ? Number(value)
    : Date.parse(value);
  const seekable = player.seekable();
  if (!Number.isFinite(requested) || !seekable?.length) return;
  const last = seekable.length - 1;
  const offset = Math.max(
    0,
    (now - (requested < 1e12 ? requested * 1000 : requested)) / 1000
  );
  player.currentTime(
    Math.max(seekable.start(last), seekable.end(last) - offset)
  );
}
export function playerSource(url) {
  const stream = scopedStreams().get(url);
  const source = {
    src: url,
    type: /\.mpd(?:[?#]|$)/i.test(url)
      ? "application/dash+xml"
      : /\.m3u8(?:[?#]|$)/i.test(url)
      ? "application/x-mpegURL"
      : "video/mp4"
  };
  if (stream?.IsDrmEnabled) {
    const authHeader =
      process.env.REACT_APP_MW_DRM_HEADER || "pallycon-customdata-v2";
    const headers = (key) => (authHeader && key ? { [authHeader]: key } : {});
    source.keySystems = {};
    if (stream.WidevineServerUrl)
      source.keySystems["com.widevine.alpha"] = {
        url: stream.WidevineServerUrl,
        licenseHeaders: headers(stream.DrmAuthKey)
      };
    if (stream.PlayReadyServerUrl)
      source.keySystems["com.microsoft.playready"] = {
        url: stream.PlayReadyServerUrl,
        licenseHeaders: headers(stream.DrmAuthKey)
      };
    if (stream.FairPlayServerUrl)
      source.keySystems["com.apple.fps.1_0"] = fairPlay(
        stream,
        headers(stream.DrmFairPlayAuthKey)
      );
  }
  return source;
}
